import { render, staticRenderFns } from "./MandateStep2.vue?vue&type=template&id=170c28b5&scoped=true&"
import script from "./MandateStep2.vue?vue&type=script&lang=js&"
export * from "./MandateStep2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170c28b5",
  null
  
)

export default component.exports